// store/Slices/organizationSlice.ts
import { StateCreator } from "zustand";
import {
  AuthSlice,
  MessageSlice,
  ThemeSlice,
  RegisterSlice,
  SectionSlice,
  OptionSlice,
  OrganizationSlice,
} from "../../interfaces";

export const createOrganizationSlice: StateCreator<
  RegisterSlice &
    SectionSlice &
    MessageSlice &
    AuthSlice &
    OptionSlice &
    OrganizationSlice &
    ThemeSlice,
  [["zustand/persist", unknown]],
  [],
  OrganizationSlice
> = (set: any, get: any) => {
  return {
    organizationZustand: "",
    decryptedInfoToken: null, // ADICIONE ESTE ESTADO

    /**
     * MERGE, não substituição.
     *
     * Quem salva uma configuração chama isto com `{ InfoToken: ... }` e só. Com
     * a substituição, todo o resto do objeto ia embora junto — em particular
     * `organizationLogoUrl`, que a TopBar usa para pintar a marca. O sintoma
     * era a logo do restaurante sumir da barra de cima depois de salvar
     * qualquer coisa, e voltar sozinha no reload seguinte.
     *
     * O merge é raso porque o objeto é raso: `InfoToken` (string) e os dados da
     * organização, lado a lado. Chave nova sobrescreve chave velha; chave não
     * mencionada fica.
     */
    setOrganizationZustand: (data: any) => {
      set((state: any) => ({
        organizationZustand:
          typeof state.organizationZustand === "object" &&
          state.organizationZustand !== null
            ? { ...state.organizationZustand, ...data }
            : data,
      }));
    },

    // ADICIONE ESTAS AÇÕES
    setDecryptedInfoToken: (decryptedInfoToken: any) => {
      set({ decryptedInfoToken });
    },

    updateOrganizationData: (organization: any, decryptedInfoToken: any) => {
      set({
        organizationZustand: organization,
        decryptedInfoToken: decryptedInfoToken,
      });
    },
  };
};
